(function () {
  const productArea = document.querySelector('.product-area[data-section-type="product-template"]');
  if (!productArea) return;

  const variantPicker = productArea.querySelector('.product-options');
  if (!variantPicker) return;

  // Track which options have been interacted with
  // option-selector elements are indexed 1, 2, 3...
  const optionSelectors = productArea.querySelectorAll('.option-selector[data-index]');
  const interacted = {};

  // Listen for the theme's own variant change event to know when selections are made
  productArea.addEventListener('on:variant:change', function (evt) {
	// Mark all currently selected options as interacted
	optionSelectors.forEach(function (selector) {
	  const index = selector.dataset.index;
	  const activeOption = selector.querySelector('[aria-selected="true"]');
	  if (activeOption && activeOption.dataset.value) {
		interacted[index] = true;
	  }
	});
	updateButtonLabels();
  });

  // Also capture direct clicks on custom-select listbox items
  variantPicker.addEventListener('click', function (e) {
	const option = e.target.closest('.js-option');
	if (!option) return;
	const selector = option.closest('.option-selector[data-index]');
	if (selector) {
	  interacted[selector.dataset.index] = true;
	}
  });

  function getUnselectedOptions() {
	const missing = [];
	optionSelectors.forEach(function (selector) {
	  const index = selector.dataset.index;
	  const label = selector.querySelector('.label');
	  const activeOption = selector.querySelector('[aria-selected="true"]');
	  const hasValue = activeOption && activeOption.dataset.value;

	  if (!hasValue || !interacted[index]) {
		const name = label ? label.textContent.trim().replace(':', '') : 'Option ' + index;
		if (name.toLowerCase() === 'color' || name.toLowerCase() === 'colour') return;
		missing.push(name);
	  }
	});
	return missing;
  }

  function showError(messages) {
	removeError();
	const err = document.createElement('p');
	err.id = 'variant-selection-error';
	err.setAttribute('role', 'alert');
	err.style.cssText = 'color: red; font-size: 0.875em; margin-bottom: 12px;';
	err.textContent = 'Please select a ' + messages.join(' and a ') + ' before adding to cart.';

	const actionArea = productArea.querySelector('.product-detail__form__action');
	if (actionArea) {
	  actionArea.insertAdjacentElement('beforebegin', err);
	}
  }

  function removeError() {
	const existing = document.getElementById('variant-selection-error');
	if (existing) existing.remove();
  }

  function updateButtonLabels() {
	removeError();
  }

  // Intercept the add to cart button click directly
  // (handles both regular submit and the sticky ATC button)
  productArea.addEventListener('click', function (e) {
	const submitBtn = e.target.closest('button[type="submit"][name="add"]');
	if (!submitBtn) return;

	const missing = getUnselectedOptions();
	if (missing.length > 0) {
	  e.preventDefault();
	  e.stopImmediatePropagation();
	  showError(missing);

	  // Highlight the first unselected dropdown
	  const firstUnselected = productArea.querySelector(
		'.option-selector[data-index]:not([data-interacted])'
	  );
	  const firstBtn = variantPicker.querySelector(
		'.option-selector .custom-select__btn'
	  );
	  if (firstBtn) firstBtn.focus();
	}
  }, true); // capture phase so we beat the theme's handler

  // Remove error once any option is changed
  productArea.addEventListener('on:variant:change', removeError);

})();